export default __webpack_public_path__ + "static/media/AdobeStock_274568994.2697093e.jpg";